<app-base-modal
  title="welcome to flip*"
  size="wide"
  titleColor="var(--color-parchment)"
  closeIconColor="var(--color-parchment)"
  [gradientBackground]="'linear-gradient(to bottom, var(--color-wisteria), var(--color-glacier))'"
  (closed)="closeDialog()"
>
  <div class="onboarding-promo__doodat-wrap">
    <img
      class="onboarding-promo__doodat"
      src="assets/account/hooray-doodat.png"
      alt=""
      aria-hidden="true"
    />
  </div>

  <h2 class="onboarding-promo__subtitle">we're so glad you're here!</h2>

  <div class="onboarding-promo__message">
    <p>
      As one of our beta members, we'd love to help you get the most out of
      flip*. If you'd like a little guidance, we're offering free one-on-one
      Zoom walkthroughs with a member of our team.
    </p>
    <p>
      We'll show you around the app, explain how everything fits together,
      answer your questions and help you get started with confidence.
    </p>
  </div>

  <div actions class="onboarding-promo__actions">
    <button
      type="button"
      class="onboarding-promo__cta visit-community"
      (click)="closeDialog('/community')"
    >
      Visit Community
    </button>
    <button
      type="button"
      class="onboarding-promo__cta maybe-later"
      (click)="closeDialog()"
    >
      Maybe Later
    </button>
  </div>
</app-base-modal>
